module.exports = __webpack_public_path__ + "static/media/whatsapp.d89731b4.svg";